module.exports = __webpack_public_path__ + "img/bow_width.51c171ef.png";